/* eslint-disable indent */
// for some reason, the linter complains about the PERFECTLY VALID
// indentation of the `switch` block.

/**
 * @param {string} whichFuel
 * @param {boolean} isNowRequired
 * @param {SettingsFiltersState} state
 * @returns {SettingsFiltersState}
 */
export function fuelRequirementChanged(whichFuel, isNowRequired, state) {
  const newState = {
    ...state,
    /**
     * We make a copy because we're locally mutating this reference below
     */
    fuelsRequired: { ...state.fuelsRequired },
    showFuelsRequiredLoadingMessage: true,
  };

  if (isNowRequired === false) {
    switch (whichFuel) {
      case 'electricity':
        /**
         * Require at least one fuel to be selected
         */
        if (state.fuelsRequired.gas === true) {
          newState.fuelsRequired.electricity = false;

          /**
           * Can't have solar if you ain't want Elec
           */
          newState.hasSolarPanels = false;
        }
        break;
      case 'gas':
        /**
         * Require at least one fuel to be selected
         */
        if (state.fuelsRequired.electricity === true) {
          newState.fuelsRequired.gas = false;
        }
        break;
      default:
        throw new RangeError(`Unknown fuel "${whichFuel}"`);
    }
  } else {
    newState.fuelsRequired[whichFuel] = true;
  }

  return newState;
}

/**
 * @param {boolean} hasSolarPanels
 * @param {SettingsFiltersState} state
 * @returns {SettingsFiltersState}
 */
export function hasSolarPanelsChanged(hasSolarPanels, state) {
  if (hasSolarPanels === true) {
    return {
      ...state,
      fuelsRequired: {
        ...state.fuelsRequired,
        /**
         * Gotta have Elec if you want solar
         */
        electricity: true,
      },
      showSolarPanelsLoadingMessage: true,
      hasSolarPanels: true,
    };
  }
  return {
    ...state,
    showSolarPanelsLoadingMessage: true,
    hasSolarPanels: false,
  };
}

/**
 * @param {Bool} isCustomerMoving
 * @param {SettingsFiltersState} state
 * @returns {SettingsFiltersState}
 */
export function hasCustomerMovingChanged(isCustomerMoving, state) {
  return {
    ...state,
    isCustomerMoving,
  };
}

/**
 * @param {string} whichFuel
 * @param {string} newUsageLevel
 * @param {SettingsFiltersState} state
 * @returns {SettingsFiltersState}
 */
export function renewableEnergyChanged(whichFuel, newUsageLevel, state) {
  if (whichFuel === 'gas' || whichFuel === 'electricity') {
    return {
      ...state,
      renewableEnergy: Object.assign({}, state.renewableEnergy, {
        [whichFuel]: newUsageLevel,
      }),
      showRenewableEnergyLoadingMessage: true,
    };
  }
  throw new Error(`Unknown fuel "${whichFuel}": expecting "gas" or "electricity"`);
}
export function postcodeChanged(newPostcode, state) {
  return {
    ...state,
    postcode: newPostcode,
  };
}
